<template>
  <div class="ThreePointsComponent">
    <v-layout wrap>
      <v-flex :class="flexClass">
        <slot name="one"/>
      </v-flex>
      <v-flex :class="flexClass">
        <slot name="two"/>
      </v-flex>
      <v-flex :class="flexClass">
        <slot name="three"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'ThreePoints',
    components: {},
    props: {
      // https://vuejs.org/v2/guide/components.html#Prop-Validation
      // propname: String
    },
    computed: {},
    watch: {},
    data: function () {
      return {
        flexClass: [
          'xs12',
          'md4'
        ]
      }
    },
    methods: {},
    created () {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .ThreePointsComponent {
  }
</style>
